import React from 'react';
import _ from 'lodash';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Form, message, Input } from 'antd';

import { useUpdateComment } from '../../hooks/useUpdateComment';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useRosaResultContext } from './context';
import { Title } from '@/components/Typography';
import { useSearchParams } from '@/hooks/v1';

const { TextArea } = Input;

interface CommentProps {
	disableEditComment: boolean;
	onCommentChange: (editingComment: boolean) => void;
}

const { useFormInstance } = Form;

export const Comment: React.FC<CommentProps> = ({ onCommentChange, disableEditComment }) => {
	const { setFieldValue } = useFormInstance();
	const { rosaResult } = useRosaResultContext();
	const { organization, company } = useApplicationContext();
	const { organization_id = organization?.id, company_id = company?.id } = useSearchParams<any>();

	const [, contextHolder] = message.useMessage();
	const { mutateAsync, isLoading } = useUpdateComment();

	const setComment = _.debounce(async (value) => {
		onCommentChange(true);
		await updateComment(value);
		onCommentChange(false);
	}, 1200);

	async function updateComment(text: string) {
		const parameters: any = {
			comment: text,
			company_id: company_id,
			report_id: rosaResult.id,
			organization_id: organization_id
		};

		const updatedComment = await mutateAsync(parameters);
		if (updatedComment?.id) {
			setFieldValue('comment', updatedComment.comment);
		}
	}

	function handleChange(text: string) {
		setComment(text);
	}

	return (
		<Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
			<Col xs={24}>
				<Title style={{ margin: 0 }} level={4}>
					{I18n.get('Comment')}
				</Title>
				{contextHolder}
			</Col>
			<Col xs={24}>
				<Form.Item name={['comment']} labelCol={{ xs: 24 }}>
					<TextArea
						rows={4}
						maxLength={500}
						showCount={true}
						onChange={(event) => handleChange(event.target.value)}
						disabled={isLoading || disableEditComment}
					/>
				</Form.Item>
			</Col>
		</Row>
	);
};
